import React, { useState, useRef, useEffect } from 'react'

import styled, { ThemeProvider } from 'styled-components'
import { lightTheme, darkTheme, GlobalStyles } from '../themes.js'
import './styles/about.scss'

import wh from '../assets/img/wh.gif'

function About(themeData) {

  useEffect(() => {
    document.title = 'About • IBIS GlobaLink Co., Ltd..';
  }, []);
  
    return (
        <ThemeProvider theme={themeData.theme === 'light' ? lightTheme : darkTheme}>
        <GlobalStyles />
        <div id='about'>

          <section className="about section-top section-bottom">
            <div className='pagetopMargin'></div>
            <div className="wrapper">
                <div className="flex flex-column">
                    <span className="title">About IBIS</span>
                </div>
            </div>

            <div className='wrapper'>
              <div className='about-container'>
                <div className='right'>
                  <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Company Name</span>
                      <span className='details'>IBIS GlobaLink Co., Ltd..</span>
                    </div>
                  </div>
                  <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Capital</span>
                      <span className='details'>3 Million Yen</span>
                    </div>
                  </div>
                  <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Foundation</span>
                      <span className='details'>July 2, 2025</span>
                    </div>
                  </div>
                  <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Representative Director / Chief Operating Officer</span>
                      <span className='details'>Kenya Ishii</span>
                    </div>
                  </div>
                  <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Main Bank</span>
                      <span className='details'>Sumitomo Mitsui Banking Corporation (SMBC) <br /> Ginza Branch</span>
                    </div>
                  </div>
                  <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Head Office Address</span>
                      <span className='details'>6F Hatsune Mori Bldg, 2-27-9 Higashi-Nihonbashi, Chuo-ku, Tokyo, Japan, 103-0004</span>
                    </div>
                  </div>
                  <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Sales Office Address</span>
                      <span className='details'>3F Yamashiro Bldg, 1-1 Kanda Ogawamachi, Chiyoda-ku, Tokyo, Japan, 101-0052</span>
                    </div>
                  </div>
                  <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Telephone</span>
                      <span className='details'>81-3-6260-5020</span>
                    </div>
                  </div>
                  <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Fax</span>
                      <span className='details'>81-3-6260-5021</span>
                    </div>
                  </div>
                  <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Website</span>
                      <span className='details'>www.ibis-globalink.co.jp</span>
                    </div>
                  </div>
                  <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Email</span>
                      <span className='details'>logi@ibis-globalink.co.jp</span>
                    </div>
                  </div>
                  <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Main Business</span>
                      <span className='details'>Air/Sea freight forwarding <br /> Logistics Service <br /> Logistics Consulting</span>
                    </div>
                  </div>
                </div>
                <div className='left'>
                  <img src={wh} alt="CEO" />
                  <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Warehouse Address </span>
                      <span className='details'>IBIS GlobaLink Warehouse Seino Center  <br /> 1-3-7 Shinsuna, Koto-ku Tokyo, Japan 136-0075</span>
                    </div>
                  </div>
                  <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Total Floor Area</span>
                      <span className='details'>2,500 sqm</span>
                    </div>
                  </div>
                  <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Service Details</span>
                      <span className='details'>Temporary Storage <br /> Long-term Storage <br /> Export Packing <br /> Inspection</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </section>

        </div>
        </ThemeProvider>
        
    )
}

export default About;